import { message } from 'antd';
import { Dispatch, Store } from 'redux';
import confirmCareTeamAssignmentImpact from '@utils/confirmCareTeamAssignmentImpact';
import waitForStoreUpdate from '@utils/waitForStoreUpdate';
import { editDashboardUser } from './actions';
import {
  toDashboardUserOrganisationUserEdit,
  DashboardUserOrganisationUserEditValues,
} from './edit';
import { selectDashboardUserEditing } from './reducers';
import { DashboardUser } from './types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export type SubmitOwnOrganisationDashboardUserEditOptions = {
  currentUser: DashboardUser;
  values: DashboardUserOrganisationUserEditValues;
  userId: string;
  dispatch: Dispatch;
  store: Store;
  t: Translate;
};

/** Own-Organisation edit submit: preview-confirm only for Care Team Flag true→false. */
export default async function submitOwnOrganisationDashboardUserEdit({
  currentUser,
  values,
  userId,
  dispatch,
  store,
  t,
}: SubmitOwnOrganisationDashboardUserEditOptions): Promise<void> {
  const edit = toDashboardUserOrganisationUserEdit(currentUser, values);
  const organisationSlug = currentUser.hospitalId;

  const runEdit = () => {
    dispatch(editDashboardUser(userId, organisationSlug, edit));
    return waitForStoreUpdate(store, state => [selectDashboardUserEditing(state)]);
  };

  if (Boolean(currentUser.careTeamMember) && values.careTeamFlag === false) {
    await confirmCareTeamAssignmentImpact({
      organisationSlug,
      userId,
      dispatch,
      store,
      t,
      whenEmpty: 'proceed',
      onConfirm: runEdit,
    });
    return;
  }

  if (!organisationSlug) {
    message.error(t('common:careTeamAssignmentImpact.missingOrganisationSlug'));
    return;
  }

  await runEdit();
}
